import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ForwardDrawTable from "@components/table/zenith/ForwardDrawTable";
import { useApprovalTabsContext } from "@components/layout/zenith/ApprovalTabs";
import { useAdministrativeApproval } from "@hooks/query/zenith/useAdministrativeApproval";
import ForwardDrawModal from "@components/modal/ForwardDrawModal";

const ForwardDrawIndex = () => {
  const { t } = useTranslation();
  const { setBreadcrumbs } = useApprovalTabsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const approvalId = searchParams.get("id") ?? "";
  const { data } = useAdministrativeApproval(approvalId);

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: t("approval.forward_draws.title"),
      },
    ]);
  }, [t, setBreadcrumbs]);

  const handleClose = () => {
    searchParams.delete("id");
    setSearchParams();
  };

  return (
    <>
      <ForwardDrawTable />
      {approvalId && data ? (
        <ForwardDrawModal
          data={data}
          onClose={handleClose}
          actionButtons={
            <button className="btn-default" onClick={handleClose}>
              {t("common.close")}
            </button>
          }
        />
      ) : null}
    </>
  );
};

export default ForwardDrawIndex;
